//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.5.0.0 (NJsonSchema v11.4.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { AxiosPromise } from 'axios';
import ApiService, { IAjaxOptions, AxiosMethod } from '@app/Services/ApiService';
export class BaseApiModelClass< T > {
    constructor(data?: T & {}) {
        if (data)
            for (let property in data)
                if (data.hasOwnProperty(property))
                    (< any >this)[property] = (< any >data)[property];
    }
}
export interface IAircraftsParams {
    onlyInService?: boolean
    onlyWk?: boolean
}
export interface IAircraftTypesParams {
    onlyInUse?: boolean
}
export interface IMaintenanceParams {
    dateFrom?: Date
    dateTo?: Date
}
export interface IGetByCodeParams {
    threeLetterCode: string
}
export interface IGetAllPOSTParams {
    body?: AirportFilter
}
export interface IGetAllGETParams {
    keys?: string
}
export interface IPutParams {
    body?: ConfigurationModel
}
export interface IPingParams {}
export interface IGetVersionParams {}
export interface IGetEmailsParams {
    body?: EmailFilter
}
export interface IGetEmailBodyParams {
    emailId?: string
}
export interface IGetEmailAttachmentsParams {
    emailId?: string
}
export interface IGetAttachmentParams {
    id?: string
}
export interface IValidateParams {
    body?: EmailValidateRequest
}
export interface IUpdateStatusParams {
    id: string
    status: MailQueueStatus
}
export interface IBookableSegmentsParams {
    dateFrom?: Date
    dateTo?: Date
    body?: BookableSegmentDxFilterModel
}
export interface IBuildBookableSegmentsParams {
    flightIds?:string[] | string 
}
export interface IFlightsParams {
    dateFrom?: Date
    dateTo?: Date
    ids?: string
}
export interface IDxFlightsParams {
    dateFrom?: Date
    dateTo?: Date
    body?: FlightDxFilterModel
}
export interface IGetAllGET2Params {
    year: number
    month: number
    day: number
}
export interface IGetFlightInfosParams {
    date?: Date
    destination?: string
}
export interface IDecodeParams {
    flightId?: string
}
export interface IPutFlightInformationParams {
    body?: FlightInformationEditModel
}
export interface IServiceBusMessagesForPersonDayParams {
    flightId?: string
}
export interface IGetAllParams {}
export interface IUpsertParams {
    body?: UpsertGuidelineModel
}
export interface IDeleteParams {
    id: string
}
export interface ILoadRoomParams {
    body?: UpsertIrregRoomModel
}
export interface ITestSegmentParams {
    body?: IrregRoomBookableSegmentModel
}
export interface IGetRoomSegmentsParams {
    id: string
}
export interface IUndoRoomParams {
    body?: IrregRoomUndoModel
}
export interface IReloadRoomPassengersParams {
    id: string
}
export interface ISearchRoomsParams {
    body?: IrregRoomSearchModel
}
export interface IGetRoomPassengersParams {
    roomId: string
    body?: IrregRoomPassengerFilterModel
}
export interface IGetRoomLogsParams {
    body?: IrregRoomLogFilterModel
}
export interface IGetAmadeusProcessLogParams {
    body?: AmadeusProcessLogFilterModel
}
export interface IGetByIdParams {
    id: string
    includeRemoved?: boolean
}
export interface ISendPassengersParams {
    body?: IrregRoomNewMessageModel
}
export interface IExportFlightDetailsParams {
    format?: ExportFormat
    roomId?: string
}
export interface IListParams {}
export interface IGetByNameParams {
    jobName: string
}
export interface IGetByIdParams {
    id: string
}
export interface IStartParams {
    jobName: string
    body?: JobStartModel
}
export interface IParametersGETParams {
    jobName: string
    triggerName?: string
    isJobSettings?: boolean
}
export interface IParametersPOSTParams {
    cronExpression: string
}
export interface IParametersPOST2Params {
    triggerName: string
    body?: JobSaveParametersModel
}
export interface ISettingsParams {
    jobName: string
    body?: JobSaveParametersModel
}
export interface ICreateParams {
    body?: JobSaveParametersModel
}
export interface IDeleteParams {
    triggerId?: string
    jobName?: string
}
export interface IIsTriggerNameUniqueParams {
    triggerName?: string
}
export interface IStopParams {
    jobName: string
    jobExecutionId?: string
}
export interface IGetAgenciesParams {
    body?: AgencyFilter
}
export interface IGetChangeLogParams {
    body?: ChangeLogFilter
}
export interface IGetTaxConfigsParams {
    body?: TaxConfigFilter
}
export interface IGetBannersParams {}
export interface IDeleteBannerAsnycParams {
    bannerId: string
}
export interface IGetActualBannersParams {}
export interface IUpsertBannerParams {
    body?: BannerModel
}
export interface IDeleteAgencyParams {
    agencyId: string
}
export interface IDeleteTaxConfigParams {
    taxConfigId: string
}
export interface IUpsertAgencyParams {
    body?: AgencyModel
}
export interface IUpsertTaxConfigParams {
    body?: TaxConfigModel
}
export interface IUpdatePassengerParams {
    body?: IrregRoomPassengerModel
}
export interface IGetLogsParams {
    body?: PassengerLogFilter
}
export interface ILoadMissingPassengersParams {
    body?: ReloadPassengersData
}
export interface IGetSavedBookingParams {
    pnr: string
}
export interface IGetSavedRemarksParams {
    pnr: string
}
export interface ILoadMissingPassengersFromFileParams {
    roomId?: string
    format?: ImportFormat
    acceptWarnings?: boolean
    file?: FileParameter
}
export interface IGetAllGET3Params {}
export interface IGetRolesParams {}
export interface IGetForRoleParams {
    roleId: number
}
export interface IGetPrincipalsParams {}
export interface IMonitoringParams {}
export interface IMonitoringJobParams {
    jobName: string
    duration?: number
}
export interface IGetParams {}
export interface ICheckMonitoringJobsParams {}
export interface ICheckMonitoringSignalRParams {}
export interface IDatabaseParams {}
export interface ICheckMonitoringDatabaseParams {}
export interface IGetAmadeusTestHistoryParams {
    dateFrom?: Date
    dateTo?: Date
}
export interface IUpdateDatabaseParams {}
export interface IDownloadMessagesParams {
    fromDateTime?: Date
    toDateTime?: Date
    labelFilter?: string
    tagFilter?: string
}
export interface IGetMessageLabelsParams {
    fromDateTime?: Date
    toDateTime?: Date
}
export interface IGetMessageTagsParams {
    fromDateTime?: Date
    toDateTime?: Date
    labelFilter?: string
}
export interface IGetLogFilesParams {
    date?: Date
}
export interface IDownloadLogParams {
    file?: string
}
export interface IDownloadLogGzParams {
    file?: string
}
export interface IDeleteLogFileParams {
    file?: string
}
export interface IDownloadDeadlettersParams {}
export interface IMessageStatisticsParams {
    dateTimeFrom?: Date
}
export interface IGetDatesWithLogsListParams {}
export interface IGetMessagesDatesListParams {}
export interface IRestartSchedulerParams {}
export interface IQueueStatisticsParams {}
export interface IQueueDeadlettersParams {}
export interface IDeleteDeadletterParams {
    id?: string
}
export interface IGetTemplateGroupsParams {}
export interface IGetByCode2Params {
    group: string
    code: string
}
export interface IGetFormattedTemplateParams {
    group: string
    code: string
    body?: TemplateFormattingModel
}
export interface IUpdateTemplateParams {
    group: string
    code: string
    body?: TemplateModel
}
export interface IGetTemplateDataModelParams {
    group: string
    code: string
}
export interface ILocalToUtcParams {
    body?: TimeModel
}
export interface IUtcToLocalParams {
    body?: TimeModel
}
export interface IAvailableTimezonesParams {
    body?: TimeModel
}
export interface ITimezoneOffsetsParams {}
export interface IDefaultTimezoneOffsetParams {}
export interface IGetSwissTimeTransitionsParams {
    periodFrom?: Date
    periodTo?: Date
}
export interface IAddNewRuleParams {
    body?: ValidationRuleModel
}
export interface IUpdateRuleParams {
    body?: ValidationRuleModel
}
export interface IDeleteRuleParams {
    ruleId?: string
}
export interface IGetAllRulesParams {}
export interface IGetValidatorsDetailsParams {}
export interface IValidateParams {
    roomId: string
    autoCorrect?: boolean
}
export class ApiClient {
    private baseUrl: string;
    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    aircraftGet(params?:IAircraftsParams, requestOptions?: IAjaxOptions): AxiosPromise<AircraftDto[]> {
        let _url = this.baseUrl + "/api/Aircraft";
        return ApiService.sendRequest<AircraftDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    aircraftTypeGet(params?:IAircraftTypesParams, requestOptions?: IAjaxOptions): AxiosPromise<AircraftTypeDto[]> {
        let _url = this.baseUrl + "/api/Aircraft/type";
        return ApiService.sendRequest<AircraftTypeDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    aircraftMaintenanceGet(params?:IMaintenanceParams, requestOptions?: IAjaxOptions): AxiosPromise<AircraftMaintenanceDto[]> {
        let _url = this.baseUrl + "/api/Aircraft/maintenance";
        return ApiService.sendRequest<AircraftMaintenanceDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    airportGetByThreeLetterCode(params?:IGetByCodeParams, requestOptions?: IAjaxOptions): AxiosPromise<AirportModel> {
        let _url = this.baseUrl + "/api/Airport/{threeLetterCode}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<AirportModel>(AxiosMethod.GET, _url, params, requestOptions);
    }
    airportPost(body: AirportFilter, requestOptions?: IAjaxOptions): AxiosPromise<AirportModel[]> {
        let _url = this.baseUrl + "/api/Airport";
        return ApiService.sendRequest<AirportModel[]>(AxiosMethod.POST, _url, body, requestOptions);
    }
    configurationGet(params?:IGetAllGETParams, requestOptions?: IAjaxOptions): AxiosPromise<ConfigurationModel[]> {
        let _url = this.baseUrl + "/api/Configuration";
        return ApiService.sendRequest<ConfigurationModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    configurationPut(body: ConfigurationModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Configuration";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    devPingGet( requestOptions?: IAjaxOptions): AxiosPromise<string> {
        let _url = this.baseUrl + "/api/Dev/ping";
        return ApiService.sendRequest<string>(AxiosMethod.GET, _url, null, requestOptions);
    }
    devVersionGet( requestOptions?: IAjaxOptions): AxiosPromise<string> {
        let _url = this.baseUrl + "/api/Dev/version";
        return ApiService.sendRequest<string>(AxiosMethod.GET, _url, null, requestOptions);
    }
    emailPost(body: EmailFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeEmailViewerGridData> {
        let _url = this.baseUrl + "/api/Email";
        return ApiService.sendRequest<DevExtremeEmailViewerGridData>(AxiosMethod.POST, _url, body, requestOptions);
    }
    emailBodyGet(params?:IGetEmailBodyParams, requestOptions?: IAjaxOptions): AxiosPromise<string> {
        let _url = this.baseUrl + "/api/Email/body";
        return ApiService.sendRequest<string>(AxiosMethod.GET, _url, params, requestOptions);
    }
    emailAttachmentsGet(params?:IGetEmailAttachmentsParams, requestOptions?: IAjaxOptions): AxiosPromise<EmailAttachmentDto[]> {
        let _url = this.baseUrl + "/api/Email/attachments";
        return ApiService.sendRequest<EmailAttachmentDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    emailAttachmentGet(params?:IGetAttachmentParams, requestOptions?: IAjaxOptions): AxiosPromise<File> {
        let _url = this.baseUrl + "/api/Email/attachment";
        return ApiService.sendRequest<File>(AxiosMethod.GET, _url, params, requestOptions);
    }
    emailValidatePost(body: EmailValidateRequest, requestOptions?: IAjaxOptions): AxiosPromise<EmailValidateResponse> {
        let _url = this.baseUrl + "/api/Email/validate";
        return ApiService.sendRequest<EmailValidateResponse>(AxiosMethod.POST, _url, body, requestOptions);
    }
    emailUpdateStatusPostByIdStatus(params?:IUpdateStatusParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Email/update-status/{id}/{status}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, params, requestOptions);
    }
    flightBookableSegmentsPost(dateFrom: Date, dateTo: Date, body: BookableSegmentDxFilterModel, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeBookableSegmentModel> {
        let _url = this.baseUrl + "/api/Flight/bookable-segments";
        return ApiService.sendRequest<DevExtremeBookableSegmentModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    flightBuildBookableSegmentsPost(params?:IBuildBookableSegmentsParams, requestOptions?: IAjaxOptions): AxiosPromise<BookableSegmentDxDto[]> {
        let _url = this.baseUrl + "/api/Flight/build-bookable-segments";
        return ApiService.sendRequest<BookableSegmentDxDto[]>(AxiosMethod.POST, _url, params, requestOptions);
    }
    flightGet(params?:IFlightsParams, requestOptions?: IAjaxOptions): AxiosPromise<FlightDto[]> {
        let _url = this.baseUrl + "/api/Flight";
        return ApiService.sendRequest<FlightDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightPost(dateFrom: Date, dateTo: Date, body: FlightDxFilterModel, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeFlightModel> {
        let _url = this.baseUrl + "/api/Flight";
        return ApiService.sendRequest<DevExtremeFlightModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    flightGetByYearMonthDay(params?:IGetAllGET2Params, requestOptions?: IAjaxOptions): AxiosPromise<FlightModel[]> {
        let _url = this.baseUrl + "/api/Flight/{year}/{month}/{day}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<FlightModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightInfoGet(params?:IGetFlightInfosParams, requestOptions?: IAjaxOptions): AxiosPromise<FlightInfoModel[]> {
        let _url = this.baseUrl + "/api/Flight/info";
        return ApiService.sendRequest<FlightInfoModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightDecodeGet(params?:IDecodeParams, requestOptions?: IAjaxOptions): AxiosPromise<FlightIdInfo> {
        let _url = this.baseUrl + "/api/Flight/decode";
        return ApiService.sendRequest<FlightIdInfo>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightInformationPut(body: FlightInformationEditModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Flight/information";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    flightMessagesGet(params?:IServiceBusMessagesForPersonDayParams, requestOptions?: IAjaxOptions): AxiosPromise<MessageHistoryModel[]> {
        let _url = this.baseUrl + "/api/Flight/messages";
        return ApiService.sendRequest<MessageHistoryModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    guidelineGet( requestOptions?: IAjaxOptions): AxiosPromise<GuidelineModel[]> {
        let _url = this.baseUrl + "/api/Guideline";
        return ApiService.sendRequest<GuidelineModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    guidelinePost(body: UpsertGuidelineModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Guideline";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    guidelineDeleteById(params?:IDeleteParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Guideline/{id}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    irregPost(body: UpsertIrregRoomModel, requestOptions?: IAjaxOptions): AxiosPromise<string> {
        let _url = this.baseUrl + "/api/Irreg";
        return ApiService.sendRequest<string>(AxiosMethod.POST, _url, body, requestOptions);
    }
    irregSegmentTestPost(body: IrregRoomBookableSegmentModel, requestOptions?: IAjaxOptions): AxiosPromise<BookableSegmentTestResult> {
        let _url = this.baseUrl + "/api/Irreg/segment-test";
        return ApiService.sendRequest<BookableSegmentTestResult>(AxiosMethod.POST, _url, body, requestOptions);
    }
    irregSegmentsGetById(params?:IGetRoomSegmentsParams, requestOptions?: IAjaxOptions): AxiosPromise<IrregRoomSegment[]> {
        let _url = this.baseUrl + "/api/Irreg/segments/{id}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<IrregRoomSegment[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    irregUndoPost(body: IrregRoomUndoModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Irreg/undo";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    irregReloadPostById(params?:IReloadRoomPassengersParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Irreg/reload/{id}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, params, requestOptions);
    }
    irregSearchPost(body: IrregRoomSearchModel, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeIrregRoomShortModel> {
        let _url = this.baseUrl + "/api/Irreg/search";
        return ApiService.sendRequest<DevExtremeIrregRoomShortModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    irregPassengersPostByRoomId(roomId: string, body: IrregRoomPassengerFilterModel, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeIrregRoomPassengerModel> {
        let _url = this.baseUrl + "/api/Irreg/passengers/{roomId}";
        _url = ApiService.getDynamicUrl(_url, { roomId, body });
        return ApiService.sendRequest<DevExtremeIrregRoomPassengerModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    irregLogsPost(body: IrregRoomLogFilterModel, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeIrregRoomLogModel> {
        let _url = this.baseUrl + "/api/Irreg/logs";
        return ApiService.sendRequest<DevExtremeIrregRoomLogModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    irregAmadeusLogPost(body: AmadeusProcessLogFilterModel, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeAmadeusProcessLogDto> {
        let _url = this.baseUrl + "/api/Irreg/amadeus-log";
        return ApiService.sendRequest<DevExtremeAmadeusProcessLogDto>(AxiosMethod.POST, _url, body, requestOptions);
    }
    irregGetById(params?:IGetByIdParams, requestOptions?: IAjaxOptions): AxiosPromise<IrregRoomModel> {
        let _url = this.baseUrl + "/api/Irreg/{id}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<IrregRoomModel>(AxiosMethod.GET, _url, params, requestOptions);
    }
    irregSendPost(body: IrregRoomNewMessageModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Irreg/send";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    irregExportGet(params?:IExportFlightDetailsParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Irreg/export";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    jobListGet( requestOptions?: IAjaxOptions): AxiosPromise<ApiV1JobList> {
        let _url = this.baseUrl + "/api/Job/list";
        return ApiService.sendRequest<ApiV1JobList>(AxiosMethod.GET, _url, null, requestOptions);
    }
    jobNameGetByJobName(params?:IGetByNameParams, requestOptions?: IAjaxOptions): AxiosPromise<ApiV1Job> {
        let _url = this.baseUrl + "/api/Job/name/{jobName}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<ApiV1Job>(AxiosMethod.GET, _url, params, requestOptions);
    }
    jobGetById(params?:IGetByIdParams, requestOptions?: IAjaxOptions): AxiosPromise<ApiV1Job> {
        let _url = this.baseUrl + "/api/Job/{id}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<ApiV1Job>(AxiosMethod.GET, _url, params, requestOptions);
    }
    jobStartPostByJobName(jobName: string, body: JobStartModel, requestOptions?: IAjaxOptions): AxiosPromise<ApiV1JobTrigger> {
        let _url = this.baseUrl + "/api/Job/start/{jobName}";
        _url = ApiService.getDynamicUrl(_url, { jobName, body });
        return ApiService.sendRequest<ApiV1JobTrigger>(AxiosMethod.POST, _url, body, requestOptions);
    }
    jobParametersGetByJobName(params?:IParametersGETParams, requestOptions?: IAjaxOptions): AxiosPromise<JobDetailsModel> {
        let _url = this.baseUrl + "/api/Job/parameters/{jobName}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<JobDetailsModel>(AxiosMethod.GET, _url, params, requestOptions);
    }
    jobCronValidationPostByCronExpression(params?:IParametersPOSTParams, requestOptions?: IAjaxOptions): AxiosPromise<CronValidationResult> {
        let _url = this.baseUrl + "/api/Job/cron/validation/{cronExpression}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<CronValidationResult>(AxiosMethod.POST, _url, params, requestOptions);
    }
    jobParametersPostByTriggerName(triggerName: string, body: JobSaveParametersModel, requestOptions?: IAjaxOptions): AxiosPromise<ApiV1Job> {
        let _url = this.baseUrl + "/api/Job/parameters/{triggerName}";
        _url = ApiService.getDynamicUrl(_url, { triggerName, body });
        return ApiService.sendRequest<ApiV1Job>(AxiosMethod.POST, _url, body, requestOptions);
    }
    jobSettingsPostByJobName(jobName: string, body: JobSaveParametersModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Job/settings/{jobName}";
        _url = ApiService.getDynamicUrl(_url, { jobName, body });
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    jobCreatePost(body: JobSaveParametersModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Job/create";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    jobDeleteDelete(params?:IDeleteParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Job/delete";
        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    jobCheckTriggerNameGet(params?:IIsTriggerNameUniqueParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Job/check-trigger-name";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    jobStopPostByJobNameJobExecutionId(params?:IStopParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Job/stop/{jobName}/{jobExecutionId}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, params, requestOptions);
    }
    masterDataAgenciesPost(body: AgencyFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeAgencyModel> {
        let _url = this.baseUrl + "/api/MasterData/agencies";
        return ApiService.sendRequest<DevExtremeAgencyModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    masterDataLogPost(body: ChangeLogFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeChangeLogModel> {
        let _url = this.baseUrl + "/api/MasterData/log";
        return ApiService.sendRequest<DevExtremeChangeLogModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    masterDataTaxConfigsPost(body: TaxConfigFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeTaxConfigModel> {
        let _url = this.baseUrl + "/api/MasterData/tax-configs";
        return ApiService.sendRequest<DevExtremeTaxConfigModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    masterDataBannersPost( requestOptions?: IAjaxOptions): AxiosPromise<BannerModel[]> {
        let _url = this.baseUrl + "/api/MasterData/banners";
        return ApiService.sendRequest<BannerModel[]>(AxiosMethod.POST, _url, null, requestOptions);
    }
    masterDataBannersDeleteByBannerId(params?:IDeleteBannerAsnycParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/MasterData/banners/{bannerId}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    masterDataActualBannersGet( requestOptions?: IAjaxOptions): AxiosPromise<BannerModel[]> {
        let _url = this.baseUrl + "/api/MasterData/actual-banners";
        return ApiService.sendRequest<BannerModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    masterDataUpsertBannerPost(body: BannerModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/MasterData/upsert-banner";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    masterDataAgencyDeleteByAgencyId(params?:IDeleteAgencyParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/MasterData/agency/{agencyId}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    masterDataTaxConfigDeleteByTaxConfigId(params?:IDeleteTaxConfigParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/MasterData/tax-config/{taxConfigId}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    masterDataUpsertAgencyPost(body: AgencyModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/MasterData/upsert-agency";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    masterDataUpsertTaxConfigPost(body: TaxConfigModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/MasterData/upsert-tax-config";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    passengerPost(body: IrregRoomPassengerModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Passenger";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    passengerLogsPost(body: PassengerLogFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremePassengerLogModel> {
        let _url = this.baseUrl + "/api/Passenger/logs";
        return ApiService.sendRequest<DevExtremePassengerLogModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    passengerLoadPost(body: ReloadPassengersData, requestOptions?: IAjaxOptions): AxiosPromise<ImportPnrsResult> {
        let _url = this.baseUrl + "/api/Passenger/load";
        return ApiService.sendRequest<ImportPnrsResult>(AxiosMethod.POST, _url, body, requestOptions);
    }
    passengerSavedBookingGetByPnr(params?:IGetSavedBookingParams, requestOptions?: IAjaxOptions): AxiosPromise<string[]> {
        let _url = this.baseUrl + "/api/Passenger/saved-booking/{pnr}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<string[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    passengerRemarksGetByPnr(params?:IGetSavedRemarksParams, requestOptions?: IAjaxOptions): AxiosPromise<BookingRemarkModel[]> {
        let _url = this.baseUrl + "/api/Passenger/remarks/{pnr}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<BookingRemarkModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    passengerFileLoadPost(roomId: string, format: ImportFormat, acceptWarnings: boolean, file: FileParameter, requestOptions?: IAjaxOptions): AxiosPromise<ImportPnrsResult> {
        let _url = this.baseUrl + "/api/Passenger/file-load";
        return ApiService.sendRequest<ImportPnrsResult>(AxiosMethod.POST, _url, file, requestOptions);
    }
    permissionGet( requestOptions?: IAjaxOptions): AxiosPromise<PermissionModel[]> {
        let _url = this.baseUrl + "/api/Permission";
        return ApiService.sendRequest<PermissionModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    permissionRoleGet( requestOptions?: IAjaxOptions): AxiosPromise<PredefinedRoleModel[]> {
        let _url = this.baseUrl + "/api/Permission/role";
        return ApiService.sendRequest<PredefinedRoleModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    permissionRoleGetByRoleId(params?:IGetForRoleParams, requestOptions?: IAjaxOptions): AxiosPromise<PermissionModel[]> {
        let _url = this.baseUrl + "/api/Permission/role/{roleId}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<PermissionModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    permissionPrincipalsGet( requestOptions?: IAjaxOptions): AxiosPromise<PrincipalModel[]> {
        let _url = this.baseUrl + "/api/Permission/principals";
        return ApiService.sendRequest<PrincipalModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    monitoringGet( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult[]> {
        let _url = this.baseUrl + "/api/monitoring";
        return ApiService.sendRequest<SelfTestResult[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    monitoringJobGetByJobName(params?:IMonitoringJobParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/monitoring/job/{jobName}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    selfTestJobsPost( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult> {
        let _url = this.baseUrl + "/api/SelfTest/jobs";
        return ApiService.sendRequest<SelfTestResult>(AxiosMethod.POST, _url, null, requestOptions);
    }
    monitoringJobsGet( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult> {
        let _url = this.baseUrl + "/api/monitoring/jobs";
        return ApiService.sendRequest<SelfTestResult>(AxiosMethod.GET, _url, null, requestOptions);
    }
    monitoringSignalrGet( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult> {
        let _url = this.baseUrl + "/api/monitoring/signalr";
        return ApiService.sendRequest<SelfTestResult>(AxiosMethod.GET, _url, null, requestOptions);
    }
    selfTestDatabasePost( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult> {
        let _url = this.baseUrl + "/api/SelfTest/database";
        return ApiService.sendRequest<SelfTestResult>(AxiosMethod.POST, _url, null, requestOptions);
    }
    monitoringDatabaseGet( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult> {
        let _url = this.baseUrl + "/api/monitoring/database";
        return ApiService.sendRequest<SelfTestResult>(AxiosMethod.GET, _url, null, requestOptions);
    }
    selfTestAmadeusTestsGet(params?:IGetAmadeusTestHistoryParams, requestOptions?: IAjaxOptions): AxiosPromise<AmadeusTestLogModel[]> {
        let _url = this.baseUrl + "/api/SelfTest/amadeus-tests";
        return ApiService.sendRequest<AmadeusTestLogModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    selfTestUpdateDatabasePost( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult> {
        let _url = this.baseUrl + "/api/SelfTest/update-database";
        return ApiService.sendRequest<SelfTestResult>(AxiosMethod.POST, _url, null, requestOptions);
    }
    serviceDownloadMessagesGet(params?:IDownloadMessagesParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Service/download-messages";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    serviceMessageLabelsGet(params?:IGetMessageLabelsParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Service/message-labels";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    serviceMessageTagsGet(params?:IGetMessageTagsParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Service/message-tags";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    serviceLogFilesGet(params?:IGetLogFilesParams, requestOptions?: IAjaxOptions): AxiosPromise<LogFileListItemModel[]> {
        let _url = this.baseUrl + "/api/Service/log-files";
        return ApiService.sendRequest<LogFileListItemModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    serviceDownloadLogGet(params?:IDownloadLogParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Service/download-log";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    serviceDownloadLogGzGet(params?:IDownloadLogGzParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Service/download-log-gz";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    serviceLogFileDelete(params?:IDeleteLogFileParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Service/log-file";
        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    serviceDownloadDeadlettersGet( requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Service/download-deadletters";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, null, requestOptions);
    }
    serviceMessageStatisticsGet(params?:IMessageStatisticsParams, requestOptions?: IAjaxOptions): AxiosPromise<MessageStatisticsModel[]> {
        let _url = this.baseUrl + "/api/Service/message-statistics";
        return ApiService.sendRequest<MessageStatisticsModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    serviceLogsDatesGet( requestOptions?: IAjaxOptions): AxiosPromise<Date[]> {
        let _url = this.baseUrl + "/api/Service/logs-dates";
        return ApiService.sendRequest<Date[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    serviceMessagesDatesGet( requestOptions?: IAjaxOptions): AxiosPromise<Date[]> {
        let _url = this.baseUrl + "/api/Service/messages-dates";
        return ApiService.sendRequest<Date[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    serviceRestartSchedulerPost( requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Service/restart-scheduler";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, null, requestOptions);
    }
    serviceInputQueueStatisticsPost( requestOptions?: IAjaxOptions): AxiosPromise<QueueStatisticsModel[]> {
        let _url = this.baseUrl + "/api/Service/input-queue-statistics";
        return ApiService.sendRequest<QueueStatisticsModel[]>(AxiosMethod.POST, _url, null, requestOptions);
    }
    serviceInputQueueDeadlettersPost( requestOptions?: IAjaxOptions): AxiosPromise<DeadletterInfoModel[]> {
        let _url = this.baseUrl + "/api/Service/input-queue-deadletters";
        return ApiService.sendRequest<DeadletterInfoModel[]>(AxiosMethod.POST, _url, null, requestOptions);
    }
    serviceInputQueueDeadlettersDelete(params?:IDeleteDeadletterParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Service/input-queue-deadletters";
        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    templatesManagementCodesGet( requestOptions?: IAjaxOptions): AxiosPromise<TemplateGroupModel[]> {
        let _url = this.baseUrl + "/api/TemplatesManagement/codes";
        return ApiService.sendRequest<TemplateGroupModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    templatesManagementGetByGroupCode(params?:IGetByCode2Params, requestOptions?: IAjaxOptions): AxiosPromise<TemplateModel> {
        let _url = this.baseUrl + "/api/TemplatesManagement/{group}/{code}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<TemplateModel>(AxiosMethod.GET, _url, params, requestOptions);
    }
    templatesManagementPostByGroupCode(group: string, code: string, body: TemplateFormattingModel, requestOptions?: IAjaxOptions): AxiosPromise<TemplateModel> {
        let _url = this.baseUrl + "/api/TemplatesManagement/{group}/{code}";
        _url = ApiService.getDynamicUrl(_url, { group, code, body });
        return ApiService.sendRequest<TemplateModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    templatesManagementPutByGroupCode(group: string, code: string, body: TemplateModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/TemplatesManagement/{group}/{code}";
        _url = ApiService.getDynamicUrl(_url, { group, code, body });
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    templatesManagementModelGetByGroupCode(params?:IGetTemplateDataModelParams, requestOptions?: IAjaxOptions): AxiosPromise<string> {
        let _url = this.baseUrl + "/api/TemplatesManagement/{group}/{code}/model";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<string>(AxiosMethod.GET, _url, params, requestOptions);
    }
    timeLocalToUtcPost(body: TimeModel, requestOptions?: IAjaxOptions): AxiosPromise<DateTimeModel> {
        let _url = this.baseUrl + "/api/Time/local-to-utc";
        return ApiService.sendRequest<DateTimeModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    timeUtcToLocalPost(body: TimeModel, requestOptions?: IAjaxOptions): AxiosPromise<Date> {
        let _url = this.baseUrl + "/api/Time/utc-to-local";
        return ApiService.sendRequest<Date>(AxiosMethod.POST, _url, body, requestOptions);
    }
    timeAvailableTimezonesPost(body: TimeModel, requestOptions?: IAjaxOptions): AxiosPromise<string[]> {
        let _url = this.baseUrl + "/api/Time/available-timezones";
        return ApiService.sendRequest<string[]>(AxiosMethod.POST, _url, body, requestOptions);
    }
    timeTimezoneOffsetsGet( requestOptions?: IAjaxOptions): AxiosPromise<string[]> {
        let _url = this.baseUrl + "/api/Time/timezone-offsets";
        return ApiService.sendRequest<string[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    timeDefaultTimezoneGet( requestOptions?: IAjaxOptions): AxiosPromise<string> {
        let _url = this.baseUrl + "/api/Time/default-timezone";
        return ApiService.sendRequest<string>(AxiosMethod.GET, _url, null, requestOptions);
    }
    timeSwissTransitionsGet(params?:IGetSwissTimeTransitionsParams, requestOptions?: IAjaxOptions): AxiosPromise<TimeTransitionEvent[]> {
        let _url = this.baseUrl + "/api/Time/swiss-transitions";
        return ApiService.sendRequest<TimeTransitionEvent[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    validationCreatePost(body: ValidationRuleModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Validation/create";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    validationUpdatePost(body: ValidationRuleModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Validation/update";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    validationDelete(params?:IDeleteRuleParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Validation";
        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    validationGet( requestOptions?: IAjaxOptions): AxiosPromise<ValidationRuleModel[]> {
        let _url = this.baseUrl + "/api/Validation";
        return ApiService.sendRequest<ValidationRuleModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    validationDetailsGet( requestOptions?: IAjaxOptions): AxiosPromise<ValidatorDetails[]> {
        let _url = this.baseUrl + "/api/Validation/details";
        return ApiService.sendRequest<ValidatorDetails[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    validationValidateGetByRoomId(params?:IValidateParams, requestOptions?: IAjaxOptions): AxiosPromise<ValidationContext[]> {
        let _url = this.baseUrl + "/api/Validation/validate/{roomId}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<ValidationContext[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
}

export interface IAgencyFilter {
    rowLimit?: number;
}
export class AgencyFilter extends BaseApiModelClass< IAgencyFilter > implements IAgencyFilter {
    rowLimit?: number;
}

export interface IAgencyModel {
    key?: any;
    items?: any[];
    count?: number;
    summary?: any[];
    id: string;
    codeName: string;
    displayName?: string;
    emailContacts?: string;
    comment?: string;
    isActiveWithin72H: boolean;
    isActiveOutside72H: boolean;
    notificationRecipients?: string;
    receiveRebookingNotifications: boolean;
}
export class AgencyModel extends BaseApiModelClass< IAgencyModel > implements IAgencyModel {
    key?: any;
    items?: any[];
    count?: number;
    summary?: any[];
    id: string;
    codeName: string;
    displayName?: string;
    emailContacts?: string;
    comment?: string;
    isActiveWithin72H: boolean;
    isActiveOutside72H: boolean;
    notificationRecipients?: string;
    receiveRebookingNotifications: boolean;
}

export interface IAgencyModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    filter?: any[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
}
export class AgencyModelDataSourceLoadOptions extends BaseApiModelClass< IAgencyModelDataSourceLoadOptions > implements IAgencyModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    filter?: any[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
}

export interface IAircraftDto {
    id: string;
    registrationNumber: string;
    aircraftTypeRcd: string;
    inServiceDateFrom: Date;
    inServiceDateTo?: Date;
}
export class AircraftDto extends BaseApiModelClass< IAircraftDto > implements IAircraftDto {
    id: string;
    registrationNumber: string;
    aircraftTypeRcd: string;
    inServiceDateFrom: Date;
    inServiceDateTo?: Date;
}

export interface IAircraftMaintenanceDto {
    id: string;
    aircraftId: string;
    dateTimeFromUtc: Date;
    dateTimeToUtc: Date;
    title: string;
}
export class AircraftMaintenanceDto extends BaseApiModelClass< IAircraftMaintenanceDto > implements IAircraftMaintenanceDto {
    id: string;
    aircraftId: string;
    dateTimeFromUtc: Date;
    dateTimeToUtc: Date;
    title: string;
}

export interface IAircraftTypeDto {
    id: string;
    codeName: string;
    status: number;
    aircraftTypeGroupId?: string;
}
export class AircraftTypeDto extends BaseApiModelClass< IAircraftTypeDto > implements IAircraftTypeDto {
    id: string;
    codeName: string;
    status: number;
    aircraftTypeGroupId?: string;
}

export interface IAirportFilter {
    threeLetterCode?: string;
    search?: string;
    page?: number;
    pageSize?: number;
    includeDisabled: boolean;
    onlyInUse: boolean;
}
export class AirportFilter extends BaseApiModelClass< IAirportFilter > implements IAirportFilter {
    threeLetterCode?: string;
    search?: string;
    page?: number;
    pageSize?: number;
    includeDisabled: boolean;
    onlyInUse: boolean;
}

export interface IAirportModel {
    fourLetterCode: string;
    threeLetterCode: string;
    name: string;
    countryCode?: string;
    isActive: boolean;
    latitude?: number;
    longitude?: number;
}
export class AirportModel extends BaseApiModelClass< IAirportModel > implements IAirportModel {
    fourLetterCode: string;
    threeLetterCode: string;
    name: string;
    countryCode?: string;
    isActive: boolean;
    latitude?: number;
    longitude?: number;
}

export interface IAmadeusProcessLogDto {
    key?: any;
    items?: any[];
    count?: number;
    summary?: any[];
    id: string;
    uniqueProcessId: string;
    timestamp: Date;
    code?: string;
    type?: string;
    description?: string;
    message?: string;
}
export class AmadeusProcessLogDto extends BaseApiModelClass< IAmadeusProcessLogDto > implements IAmadeusProcessLogDto {
    key?: any;
    items?: any[];
    count?: number;
    summary?: any[];
    id: string;
    uniqueProcessId: string;
    timestamp: Date;
    code?: string;
    type?: string;
    description?: string;
    message?: string;
}

export interface IAmadeusProcessLogDtoDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    filter?: any[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
}
export class AmadeusProcessLogDtoDataSourceLoadOptions extends BaseApiModelClass< IAmadeusProcessLogDtoDataSourceLoadOptions > implements IAmadeusProcessLogDtoDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    filter?: any[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
}

export interface IAmadeusProcessLogFilterModel {
    rowLimit?: number;
    processId: string;
    passengerId?: string;
}
export class AmadeusProcessLogFilterModel extends BaseApiModelClass< IAmadeusProcessLogFilterModel > implements IAmadeusProcessLogFilterModel {
    rowLimit?: number;
    processId: string;
    passengerId?: string;
}

export interface IAmadeusTestLogModel {
    id: string;
    uniqueProcessId: string;
    sentAt: Date;
    amadeusSentAt?: Date;
    completedAt?: Date;
    avantikTestSucceed?: boolean;
    amadeusTestSucceed?: boolean;
    triggerId?: string;
    retry: number;
    failureNotificationSent: boolean;
    message?: string;
    serviceBusMessageId?: string;
    avantikDurationMs?: number;
    amadeusDurationMs?: number;
    totalDurationMs?: number;
}
export class AmadeusTestLogModel extends BaseApiModelClass< IAmadeusTestLogModel > implements IAmadeusTestLogModel {
    id: string;
    uniqueProcessId: string;
    sentAt: Date;
    amadeusSentAt?: Date;
    completedAt?: Date;
    avantikTestSucceed?: boolean;
    amadeusTestSucceed?: boolean;
    triggerId?: string;
    retry: number;
    failureNotificationSent: boolean;
    message?: string;
    serviceBusMessageId?: string;
    avantikDurationMs?: number;
    amadeusDurationMs?: number;
    totalDurationMs?: number;
}

export interface IApiV1Job {
    id: string;
    name: string;
    description?: string;
    jobType: string;
    lastRunDateTimeUtc?: Date;
    nextRunDateTimeUtc?: Date;
    lastRunTriggerName?: string;
    nextRunTriggerName?: string;
    lastErrorMessage?: string;
    lastStatus?: JobStatus;
    timestampDateTimeUtc: Date;
    triggers: JobTriggerShortInfo[];
    permissionName?: string;
    lastExecutionInfoMessage?: string;
}
export class ApiV1Job extends BaseApiModelClass< IApiV1Job > implements IApiV1Job {
    id: string;
    name: string;
    description?: string;
    jobType: string;
    lastRunDateTimeUtc?: Date;
    nextRunDateTimeUtc?: Date;
    lastRunTriggerName?: string;
    nextRunTriggerName?: string;
    lastErrorMessage?: string;
    lastStatus?: JobStatus;
    timestampDateTimeUtc: Date;
    triggers: JobTriggerShortInfo[];
    permissionName?: string;
    lastExecutionInfoMessage?: string;
}

export interface IApiV1JobList {
    jobs: ApiV1Job[];
    status?: SchedulerStatus;
    startupException?: string;
}
export class ApiV1JobList extends BaseApiModelClass< IApiV1JobList > implements IApiV1JobList {
    jobs: ApiV1Job[];
    status?: SchedulerStatus;
    startupException?: string;
}

export interface IApiV1JobTrigger {
    executionId?: string;
    id: string;
    nextRunDateTime?: Date;
    lastRunDateTime?: Date;
    lastErrorMessage?: string;
    status?: JobStatus;
    isActive: boolean;
    cronSchedule?: string;
    progressMessage?: string;
}
export class ApiV1JobTrigger extends BaseApiModelClass< IApiV1JobTrigger > implements IApiV1JobTrigger {
    executionId?: string;
    id: string;
    nextRunDateTime?: Date;
    lastRunDateTime?: Date;
    lastErrorMessage?: string;
    status?: JobStatus;
    isActive: boolean;
    cronSchedule?: string;
    progressMessage?: string;
}

export interface IBannerModel {
    id: string;
    title?: string;
    text?: string;
    dateFrom?: Date;
    dateTo?: Date;
    createdAt: Date;
    createdBy: string;
    modifiedAt?: Date;
    modifiedBy?: string;
}
export class BannerModel extends BaseApiModelClass< IBannerModel > implements IBannerModel {
    id: string;
    title?: string;
    text?: string;
    dateFrom?: Date;
    dateTo?: Date;
    createdAt: Date;
    createdBy: string;
    modifiedAt?: Date;
    modifiedBy?: string;
}

export interface IBookableSegmentDxDto {
    key?: any;
    items?: any[];
    count?: number;
    summary?: any[];
    id: string;
    airlineRcd: string;
    flightNumber: number;
    aircraftRegistrationNumber?: string;
    departureDateTimeUtc: Date;
    arrivalDateTimeUtc: Date;
    originRcd: string;
    destinationRcd: string;
    rotationKey?: string;
    estimatedDepartureDateTimeUtc?: Date;
    estimatedArrivalDateTimeUtc?: Date;
    offTheGroundUtc?: Date;
    intoTheGateUtc?: Date;
    cockpitCrewEmployer: string;
    cabinCrewEmployer: string;
    isDeleted: boolean;
    aircraftTypeRcd?: string;
    firstFlightId: string;
    hasOpenedRoom: boolean;
    flightIds: string[];
    roomId?: string;
}
export class BookableSegmentDxDto extends BaseApiModelClass< IBookableSegmentDxDto > implements IBookableSegmentDxDto {
    key?: any;
    items?: any[];
    count?: number;
    summary?: any[];
    id: string;
    airlineRcd: string;
    flightNumber: number;
    aircraftRegistrationNumber?: string;
    departureDateTimeUtc: Date;
    arrivalDateTimeUtc: Date;
    originRcd: string;
    destinationRcd: string;
    rotationKey?: string;
    estimatedDepartureDateTimeUtc?: Date;
    estimatedArrivalDateTimeUtc?: Date;
    offTheGroundUtc?: Date;
    intoTheGateUtc?: Date;
    cockpitCrewEmployer: string;
    cabinCrewEmployer: string;
    isDeleted: boolean;
    aircraftTypeRcd?: string;
    firstFlightId: string;
    hasOpenedRoom: boolean;
    flightIds: string[];
    roomId?: string;
}

export interface IBookableSegmentDxDtoDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    filter?: any[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
}
export class BookableSegmentDxDtoDataSourceLoadOptions extends BaseApiModelClass< IBookableSegmentDxDtoDataSourceLoadOptions > implements IBookableSegmentDxDtoDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    filter?: any[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
}

export interface IBookableSegmentDxFilterModel {
    rowLimit?: number;
}
export class BookableSegmentDxFilterModel extends BaseApiModelClass< IBookableSegmentDxFilterModel > implements IBookableSegmentDxFilterModel {
    rowLimit?: number;
}

export interface IBookableSegmentTestResult {
    successful: boolean;
    passengersCount: number;
    message?: string;
}
export class BookableSegmentTestResult extends BaseApiModelClass< IBookableSegmentTestResult > implements IBookableSegmentTestResult {
    successful: boolean;
    passengersCount: number;
    message?: string;
}

export interface IBookingRemarkModel {
    id: string;
    bookingId: string;
    avantikTypeRcd?: string;
    nickname?: string;
    text: string;
    createdAt: Date;
}
export class BookingRemarkModel extends BaseApiModelClass< IBookingRemarkModel > implements IBookingRemarkModel {
    id: string;
    bookingId: string;
    avantikTypeRcd?: string;
    nickname?: string;
    text: string;
    createdAt: Date;
}

export interface IChangeLogFilter {
    rowLimit?: number;
    changedObjectId?: string;
    changedObjectType: ChangeLogType;
}
export class ChangeLogFilter extends BaseApiModelClass< IChangeLogFilter > implements IChangeLogFilter {
    rowLimit?: number;
    changedObjectId?: string;
    changedObjectType: ChangeLogType;
}

export interface IChangeLogModel {
    key?: any;
    items?: any[];
    count?: number;
    summary?: any[];
    id: string;
    changedObjectId: string;
    timestamp: Date;
    changedBy?: string;
    field: string;
    oldValue?: string;
    newValue?: string;
}
export class ChangeLogModel extends BaseApiModelClass< IChangeLogModel > implements IChangeLogModel {
    key?: any;
    items?: any[];
    count?: number;
    summary?: any[];
    id: string;
    changedObjectId: string;
    timestamp: Date;
    changedBy?: string;
    field: string;
    oldValue?: string;
    newValue?: string;
}

export interface IChangeLogModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    filter?: any[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
}
export class ChangeLogModelDataSourceLoadOptions extends BaseApiModelClass< IChangeLogModelDataSourceLoadOptions > implements IChangeLogModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    filter?: any[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
}

export enum ChangeLogType {
    TaxConfig = "TaxConfig",
    TourOperator = "TourOperator",
}

export enum ConfigType {
    Boolean = "Boolean",
    Date = "Date",
    DateTime = "DateTime",
    Html = "Html",
    Number = "Number",
    Select = "Select",
    Text = "Text",
    Uri = "Uri",
}

export interface IConfigurationModel {
    key: string;
    group: string;
    value: string;
    description?: string;
    type?: ConfigType;
    isSystem?: boolean;
    options?: string;
}
export class ConfigurationModel extends BaseApiModelClass< IConfigurationModel > implements IConfigurationModel {
    key: string;
    group: string;
    value: string;
    description?: string;
    type?: ConfigType;
    isSystem?: boolean;
    options?: string;
}

export interface ICronValidationResult {
    isValid: boolean;
    validationErrorMessage?: string;
    expressionSummary?: string;
    nextInvalidTime?: Date;
}
export class CronValidationResult extends BaseApiModelClass< ICronValidationResult > implements ICronValidationResult {
    isValid: boolean;
    validationErrorMessage?: string;
    expressionSummary?: string;
    nextInvalidTime?: Date;
}

export interface IDateTimeModel {
    date?: Date;
}
export class DateTimeModel extends BaseApiModelClass< IDateTimeModel > implements IDateTimeModel {
    date?: Date;
}

export interface IDeadletterInfoModel {
    id: string;
    label: MessageLabel;
    messageBody: string;
    error: string;
}
export class DeadletterInfoModel extends BaseApiModelClass< IDeadletterInfoModel > implements IDeadletterInfoModel {
    id: string;
    label: MessageLabel;
    messageBody: string;
    error: string;
}

export interface IDevExtremeAgencyModel {
    data?: AgencyModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeAgencyModel extends BaseApiModelClass< IDevExtremeAgencyModel > implements IDevExtremeAgencyModel {
    data?: AgencyModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeAmadeusProcessLogDto {
    data?: AmadeusProcessLogDto[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeAmadeusProcessLogDto extends BaseApiModelClass< IDevExtremeAmadeusProcessLogDto > implements IDevExtremeAmadeusProcessLogDto {
    data?: AmadeusProcessLogDto[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeBookableSegmentModel {
    data?: BookableSegmentDxDto[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeBookableSegmentModel extends BaseApiModelClass< IDevExtremeBookableSegmentModel > implements IDevExtremeBookableSegmentModel {
    data?: BookableSegmentDxDto[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeChangeLogModel {
    data?: ChangeLogModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeChangeLogModel extends BaseApiModelClass< IDevExtremeChangeLogModel > implements IDevExtremeChangeLogModel {
    data?: ChangeLogModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeEmailViewerGridData {
    data?: DevExtremeEmailViewerItemData[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeEmailViewerGridData extends BaseApiModelClass< IDevExtremeEmailViewerGridData > implements IDevExtremeEmailViewerGridData {
    data?: DevExtremeEmailViewerItemData[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeEmailViewerItemData {
    key?: any;
    items?: any[];
    count?: number;
    summary?: any[];
    id: string;
    createdDate: Date;
    sentDate?: Date;
    from: string;
    to: string;
    subject: string;
    bodyContentType?: string;
    cc?: string;
    bcc?: string;
    type?: MailQueueType;
    label?: string;
    status: MailQueueStatus;
    hasAttachments: boolean;
    errorMessage?: string;
}
export class DevExtremeEmailViewerItemData extends BaseApiModelClass< IDevExtremeEmailViewerItemData > implements IDevExtremeEmailViewerItemData {
    key?: any;
    items?: any[];
    count?: number;
    summary?: any[];
    id: string;
    createdDate: Date;
    sentDate?: Date;
    from: string;
    to: string;
    subject: string;
    bodyContentType?: string;
    cc?: string;
    bcc?: string;
    type?: MailQueueType;
    label?: string;
    status: MailQueueStatus;
    hasAttachments: boolean;
    errorMessage?: string;
}

export interface IDevExtremeEmailViewerItemDataDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    filter?: any[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
}
export class DevExtremeEmailViewerItemDataDataSourceLoadOptions extends BaseApiModelClass< IDevExtremeEmailViewerItemDataDataSourceLoadOptions > implements IDevExtremeEmailViewerItemDataDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    filter?: any[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
}

export interface IDevExtremeFlightModel {
    data?: FlightDxDto[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeFlightModel extends BaseApiModelClass< IDevExtremeFlightModel > implements IDevExtremeFlightModel {
    data?: FlightDxDto[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeIrregRoomLogModel {
    data?: IrregRoomLogModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeIrregRoomLogModel extends BaseApiModelClass< IDevExtremeIrregRoomLogModel > implements IDevExtremeIrregRoomLogModel {
    data?: IrregRoomLogModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeIrregRoomPassengerModel {
    data?: IrregRoomPassengerModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeIrregRoomPassengerModel extends BaseApiModelClass< IDevExtremeIrregRoomPassengerModel > implements IDevExtremeIrregRoomPassengerModel {
    data?: IrregRoomPassengerModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeIrregRoomShortModel {
    data?: IrregRoomShortModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeIrregRoomShortModel extends BaseApiModelClass< IDevExtremeIrregRoomShortModel > implements IDevExtremeIrregRoomShortModel {
    data?: IrregRoomShortModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremePassengerLogModel {
    data?: PassengerLogModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremePassengerLogModel extends BaseApiModelClass< IDevExtremePassengerLogModel > implements IDevExtremePassengerLogModel {
    data?: PassengerLogModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeTaxConfigModel {
    data?: TaxConfigModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeTaxConfigModel extends BaseApiModelClass< IDevExtremeTaxConfigModel > implements IDevExtremeTaxConfigModel {
    data?: TaxConfigModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export enum DirectionType {
    DeadletterToInbox = "DeadletterToInbox",
    In = "In",
    Out = "Out",
}

export interface IEmailAttachmentDto {
    id: string;
    name?: string;
    type: EmailContentType;
    size?: number;
}
export class EmailAttachmentDto extends BaseApiModelClass< IEmailAttachmentDto > implements IEmailAttachmentDto {
    id: string;
    name?: string;
    type: EmailContentType;
    size?: number;
}

export enum EmailContentType {
    None = "None",
    Pdf = "Pdf",
    Xls = "Xls",
    Xml = "Xml",
}

export interface IEmailFilter {
    rowLimit?: number;
    periodFrom: Date;
    periodTo?: Date;
    searchTerm?: string;
}
export class EmailFilter extends BaseApiModelClass< IEmailFilter > implements IEmailFilter {
    rowLimit?: number;
    periodFrom: Date;
    periodTo?: Date;
    searchTerm?: string;
}

export interface IEmailValidateRequest {
    value?: string;
}
export class EmailValidateRequest extends BaseApiModelClass< IEmailValidateRequest > implements IEmailValidateRequest {
    value?: string;
}

export interface IEmailValidateResponse {
    isValid: boolean;
    errorMessage?: string;
}
export class EmailValidateResponse extends BaseApiModelClass< IEmailValidateResponse > implements IEmailValidateResponse {
    isValid: boolean;
    errorMessage?: string;
}

export enum ExportFormat {
    Csv = "Csv",
    Excel = "Excel",
}

export interface IFile {
}
export class File extends BaseApiModelClass< IFile > implements IFile {
}

export interface IFlightDto {
    id: string;
    airlineRcd: string;
    aircraftTypeRcd: string;
    flightNumber: number;
    operationalSuffix?: string;
    originRcd: string;
    destinationRcd: string;
    date: Date;
    netlineOpsLegId?: number;
    status: FlightStatus;
    statusIdentifier?: string;
    statusSupplementaryInfo?: string;
    statusChangeReason?: string;
    statusActionIdentifier?: string;
    isLongHaul: boolean;
    departureDateTimeUtc: Date;
    departureDateTimeLt: Date;
    arrivalDateTimeUtc: Date;
    arrivalDateTimeLt: Date;
    outOfTheGateUtc?: Date;
    offTheGroundUtc?: Date;
    onTheGroundUtc?: Date;
    intoTheGateUtc?: Date;
    aircraftId?: string;
    legSequenceNumber: number;
    originalFlightId?: string;
    estimatedDepartureDateTimeUtc?: Date;
    estimatedArrivalDateTimeUtc?: Date;
    cockpitCrewEmployer: string;
    cabinCrewEmployer: string;
    plannedAircraftTypeRcd?: string;
    hasEmptyBookableSegment: boolean;
}
export class FlightDto extends BaseApiModelClass< IFlightDto > implements IFlightDto {
    id: string;
    airlineRcd: string;
    aircraftTypeRcd: string;
    flightNumber: number;
    operationalSuffix?: string;
    originRcd: string;
    destinationRcd: string;
    date: Date;
    netlineOpsLegId?: number;
    status: FlightStatus;
    statusIdentifier?: string;
    statusSupplementaryInfo?: string;
    statusChangeReason?: string;
    statusActionIdentifier?: string;
    isLongHaul: boolean;
    departureDateTimeUtc: Date;
    departureDateTimeLt: Date;
    arrivalDateTimeUtc: Date;
    arrivalDateTimeLt: Date;
    outOfTheGateUtc?: Date;
    offTheGroundUtc?: Date;
    onTheGroundUtc?: Date;
    intoTheGateUtc?: Date;
    aircraftId?: string;
    legSequenceNumber: number;
    originalFlightId?: string;
    estimatedDepartureDateTimeUtc?: Date;
    estimatedArrivalDateTimeUtc?: Date;
    cockpitCrewEmployer: string;
    cabinCrewEmployer: string;
    plannedAircraftTypeRcd?: string;
    hasEmptyBookableSegment: boolean;
}

export interface IFlightDxDto {
    key?: any;
    items?: any[];
    count?: number;
    summary?: any[];
    id: string;
    airlineRcd: string;
    aircraftTypeRcd: string;
    flightNumber: number;
    operationalSuffix?: string;
    originRcd: string;
    destinationRcd: string;
    date: Date;
    netlineOpsLegId?: number;
    status: FlightStatus;
    statusIdentifier?: string;
    statusSupplementaryInfo?: string;
    statusChangeReason?: string;
    statusActionIdentifier?: string;
    isLongHaul: boolean;
    hasEmptyBookableSegment: boolean;
    departureDateTimeUtc: Date;
    departureDateTimeLt: Date;
    arrivalDateTimeUtc: Date;
    arrivalDateTimeLt: Date;
    outOfTheGateUtc?: Date;
    offTheGroundUtc?: Date;
    onTheGroundUtc?: Date;
    intoTheGateUtc?: Date;
    aircraftId?: string;
    legSequenceNumber: number;
    originalFlightId?: string;
    estimatedDepartureDateTimeUtc?: Date;
    estimatedArrivalDateTimeUtc?: Date;
    cockpitCrewEmployer: string;
    cabinCrewEmployer: string;
    plannedAircraftTypeRcd?: string;
}
export class FlightDxDto extends BaseApiModelClass< IFlightDxDto > implements IFlightDxDto {
    key?: any;
    items?: any[];
    count?: number;
    summary?: any[];
    id: string;
    airlineRcd: string;
    aircraftTypeRcd: string;
    flightNumber: number;
    operationalSuffix?: string;
    originRcd: string;
    destinationRcd: string;
    date: Date;
    netlineOpsLegId?: number;
    status: FlightStatus;
    statusIdentifier?: string;
    statusSupplementaryInfo?: string;
    statusChangeReason?: string;
    statusActionIdentifier?: string;
    isLongHaul: boolean;
    hasEmptyBookableSegment: boolean;
    departureDateTimeUtc: Date;
    departureDateTimeLt: Date;
    arrivalDateTimeUtc: Date;
    arrivalDateTimeLt: Date;
    outOfTheGateUtc?: Date;
    offTheGroundUtc?: Date;
    onTheGroundUtc?: Date;
    intoTheGateUtc?: Date;
    aircraftId?: string;
    legSequenceNumber: number;
    originalFlightId?: string;
    estimatedDepartureDateTimeUtc?: Date;
    estimatedArrivalDateTimeUtc?: Date;
    cockpitCrewEmployer: string;
    cabinCrewEmployer: string;
    plannedAircraftTypeRcd?: string;
}

export interface IFlightDxDtoDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    filter?: any[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
}
export class FlightDxDtoDataSourceLoadOptions extends BaseApiModelClass< IFlightDxDtoDataSourceLoadOptions > implements IFlightDxDtoDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    filter?: any[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
}

export interface IFlightDxFilterModel {
    rowLimit?: number;
}
export class FlightDxFilterModel extends BaseApiModelClass< IFlightDxFilterModel > implements IFlightDxFilterModel {
    rowLimit?: number;
}

export interface IFlightIdInfo {
    flightNumber: number;
    airlineRcd: string;
    originRcd: string;
    destinationRcd: string;
    legNumber: number;
    date: Date;
}
export class FlightIdInfo extends BaseApiModelClass< IFlightIdInfo > implements IFlightIdInfo {
    flightNumber: number;
    airlineRcd: string;
    originRcd: string;
    destinationRcd: string;
    legNumber: number;
    date: Date;
}

export interface IFlightInfoModel {
    id: string;
    flightNumber: number;
    operationalSuffix?: string;
    originRcd: string;
    destinationRcd: string;
    departureDateTimeUtc: Date;
    arrivalDateTimeUtc: Date;
    aircraftTypeRcd?: string;
    cockpitCrewEmployer?: string;
    cabinCrewEmployer?: string;
}
export class FlightInfoModel extends BaseApiModelClass< IFlightInfoModel > implements IFlightInfoModel {
    id: string;
    flightNumber: number;
    operationalSuffix?: string;
    originRcd: string;
    destinationRcd: string;
    departureDateTimeUtc: Date;
    arrivalDateTimeUtc: Date;
    aircraftTypeRcd?: string;
    cockpitCrewEmployer?: string;
    cabinCrewEmployer?: string;
}

export interface IFlightInformationEditModel {
    id: string;
    status: FlightStatus;
    arrivalDateTimeUtc: Date;
    departureDateTimeUtc: Date;
    outOfTheGateDateTimeUtc?: Date;
    offTheGroundDateTimeUtc?: Date;
    onTheGroundDateTimeUtc?: Date;
    intoTheGateDateTimeUtc?: Date;
    estimatedDepartureDateTimeUtc?: Date;
    estimatedArrivalDateTimeUtc?: Date;
    originalId?: string;
    aircraftId?: string;
    cockpitCrewEmployer?: string;
    cabinCrewEmployer?: string;
}
export class FlightInformationEditModel extends BaseApiModelClass< IFlightInformationEditModel > implements IFlightInformationEditModel {
    id: string;
    status: FlightStatus;
    arrivalDateTimeUtc: Date;
    departureDateTimeUtc: Date;
    outOfTheGateDateTimeUtc?: Date;
    offTheGroundDateTimeUtc?: Date;
    onTheGroundDateTimeUtc?: Date;
    intoTheGateDateTimeUtc?: Date;
    estimatedDepartureDateTimeUtc?: Date;
    estimatedArrivalDateTimeUtc?: Date;
    originalId?: string;
    aircraftId?: string;
    cockpitCrewEmployer?: string;
    cabinCrewEmployer?: string;
}

export interface IFlightModel {
    id: string;
    airlineRcd: string;
    flightNumber: number;
    operationalSuffix?: string;
    originRcd: string;
    destinationRcd: string;
    departureDateTimeUtc?: Date;
    arrivalDateTimeUtc?: Date;
    estimatedDepartureDateTimeUtc?: Date;
    estimatedArrivalDateTimeUtc?: Date;
    departureTimeDiffToLt: string;
    arrivalTimeDiffToLt: string;
    aircraftTypeRcd?: string;
    outTheGateDateTimeUtc?: Date;
    offTheGroundDateTimeUtc?: Date;
    onTheGroundDateTimeUtc?: Date;
    intoTheGateDateTimeUtc?: Date;
    aircraftId?: string;
    undoReason?: string;
    aircraftRegistrationNumber?: string;
}
export class FlightModel extends BaseApiModelClass< IFlightModel > implements IFlightModel {
    id: string;
    airlineRcd: string;
    flightNumber: number;
    operationalSuffix?: string;
    originRcd: string;
    destinationRcd: string;
    departureDateTimeUtc?: Date;
    arrivalDateTimeUtc?: Date;
    estimatedDepartureDateTimeUtc?: Date;
    estimatedArrivalDateTimeUtc?: Date;
    departureTimeDiffToLt: string;
    arrivalTimeDiffToLt: string;
    aircraftTypeRcd?: string;
    outTheGateDateTimeUtc?: Date;
    offTheGroundDateTimeUtc?: Date;
    onTheGroundDateTimeUtc?: Date;
    intoTheGateDateTimeUtc?: Date;
    aircraftId?: string;
    undoReason?: string;
    readonly aircraftRegistrationNumber?: string;
}

export enum FlightStatus {
    Actual = "Actual",
    Cancelled = "Cancelled",
    Changed = "Changed",
    Deleted = "Deleted",
}

export interface IGroupingInfo {
    selector?: string;
    desc: boolean;
    groupInterval?: string;
    isExpanded?: boolean;
}
export class GroupingInfo extends BaseApiModelClass< IGroupingInfo > implements IGroupingInfo {
    selector?: string;
    desc: boolean;
    groupInterval?: string;
    isExpanded?: boolean;
}

export interface IGuidelineModel {
    id: string;
    title: string;
    text: string;
    createdAt: Date;
    createdBy: string;
    modifiedAt?: Date;
    modifiedBy?: string;
}
export class GuidelineModel extends BaseApiModelClass< IGuidelineModel > implements IGuidelineModel {
    id: string;
    title: string;
    text: string;
    createdAt: Date;
    createdBy: string;
    modifiedAt?: Date;
    modifiedBy?: string;
}

export enum ImportFormat {
    PNRs = "PNRs",
    Xlsx = "Xlsx",
    Xml = "Xml",
}

export interface IImportPnrsResult {
    errors: string[];
    warnings: string[];
    info: string[];
}
export class ImportPnrsResult extends BaseApiModelClass< IImportPnrsResult > implements IImportPnrsResult {
    errors: string[];
    warnings: string[];
    info: string[];
}

export interface IIrregRoomBookableSegmentModel {
    date: Date;
    airlineRcd: string;
    originRcd: string;
    destinationRcd: string;
    flightNumber: number;
    departureDateTimeUtc?: Date;
    arrivalDateTimeUtc?: Date;
    aircraftTypeRcd?: string;
}
export class IrregRoomBookableSegmentModel extends BaseApiModelClass< IIrregRoomBookableSegmentModel > implements IIrregRoomBookableSegmentModel {
    date: Date;
    airlineRcd: string;
    originRcd: string;
    destinationRcd: string;
    flightNumber: number;
    departureDateTimeUtc?: Date;
    arrivalDateTimeUtc?: Date;
    aircraftTypeRcd?: string;
}

export interface IIrregRoomLeg {
    flightId?: string;
    flightNumber: number;
    departureDateTimeUtc?: Date;
    arrivalDateTimeUtc?: Date;
    undoReason?: string;
    airlineRcd?: string;
}
export class IrregRoomLeg extends BaseApiModelClass< IIrregRoomLeg > implements IIrregRoomLeg {
    flightId?: string;
    flightNumber: number;
    departureDateTimeUtc?: Date;
    arrivalDateTimeUtc?: Date;
    undoReason?: string;
    airlineRcd?: string;
}

export interface IIrregRoomLogFilterModel {
    rowLimit?: number;
    roomId: string;
}
export class IrregRoomLogFilterModel extends BaseApiModelClass< IIrregRoomLogFilterModel > implements IIrregRoomLogFilterModel {
    rowLimit?: number;
    roomId: string;
}

export interface IIrregRoomLogModel {
    key?: any;
    items?: any[];
    count?: number;
    summary?: any[];
    id: string;
    principalDisplayName: string;
    timestamp: Date;
    message: string;
    details?: string;
}
export class IrregRoomLogModel extends BaseApiModelClass< IIrregRoomLogModel > implements IIrregRoomLogModel {
    key?: any;
    items?: any[];
    count?: number;
    summary?: any[];
    id: string;
    principalDisplayName: string;
    timestamp: Date;
    message: string;
    details?: string;
}

export interface IIrregRoomLogModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    filter?: any[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
}
export class IrregRoomLogModelDataSourceLoadOptions extends BaseApiModelClass< IIrregRoomLogModelDataSourceLoadOptions > implements IIrregRoomLogModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    filter?: any[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
}

export interface IIrregRoomModel {
    id: string;
    createdAt: Date;
    passengersTotalCount: number;
    passengersActualCount: number;
    isComplete: boolean;
    legs: FlightModel[];
    passengers: IrregRoomPassengerModel[];
}
export class IrregRoomModel extends BaseApiModelClass< IIrregRoomModel > implements IIrregRoomModel {
    id: string;
    createdAt: Date;
    passengersTotalCount: number;
    readonly passengersActualCount: number;
    isComplete: boolean;
    legs: FlightModel[];
    passengers: IrregRoomPassengerModel[];
}

export interface IIrregRoomNewMessageModel {
    roomId: string;
    passengerIds: string[];
}
export class IrregRoomNewMessageModel extends BaseApiModelClass< IIrregRoomNewMessageModel > implements IIrregRoomNewMessageModel {
    roomId: string;
    passengerIds: string[];
}

export interface IIrregRoomPassengerFilterModel {
    rowLimit?: number;
    includeRemoved: boolean;
}
export class IrregRoomPassengerFilterModel extends BaseApiModelClass< IIrregRoomPassengerFilterModel > implements IIrregRoomPassengerFilterModel {
    rowLimit?: number;
    includeRemoved: boolean;
}

export interface IIrregRoomPassengerModel {
    key?: any;
    items?: any[];
    count?: number;
    summary?: any[];
    id: string;
    uniqueProcessId?: string;
    avantikId?: string;
    avantikGuardianId?: string;
    batchNumber: number;
    title?: string;
    type?: string;
    pnr: string;
    lastName?: string;
    firstName?: string;
    genderType?: string;
    birthDate?: Date;
    amadeusTicketNumber?: string;
    amadeusPnr?: string;
    languageRcd?: string;
    agencyCode?: string;
    originRcd?: string;
    destinationRcd?: string;
    departureOriginRcd?: string;
    departureDestinationRcd?: string;
    arrivalOriginRcd?: string;
    arrivalDestinationRcd?: string;
    phoneNumber?: string;
    email?: string;
    comment?: string;
    seatNumber?: string;
    status: PassengerStatus;
    bookingClassRcd?: string;
    boardingClassRcd?: string;
    services?: string;
    wasAutoCorrected: boolean;
    infants: IrregRoomPassengerModel[];
    leg: IrregRoomLeg;
}
export class IrregRoomPassengerModel extends BaseApiModelClass< IIrregRoomPassengerModel > implements IIrregRoomPassengerModel {
    key?: any;
    items?: any[];
    count?: number;
    summary?: any[];
    id: string;
    uniqueProcessId?: string;
    avantikId?: string;
    avantikGuardianId?: string;
    batchNumber: number;
    title?: string;
    type?: string;
    pnr: string;
    lastName?: string;
    firstName?: string;
    genderType?: string;
    birthDate?: Date;
    amadeusTicketNumber?: string;
    amadeusPnr?: string;
    languageRcd?: string;
    agencyCode?: string;
    originRcd?: string;
    destinationRcd?: string;
    departureOriginRcd?: string;
    departureDestinationRcd?: string;
    arrivalOriginRcd?: string;
    arrivalDestinationRcd?: string;
    phoneNumber?: string;
    email?: string;
    comment?: string;
    seatNumber?: string;
    status: PassengerStatus;
    bookingClassRcd?: string;
    boardingClassRcd?: string;
    services?: string;
    wasAutoCorrected: boolean;
    infants: IrregRoomPassengerModel[];
    leg: IrregRoomLeg;
}

export interface IIrregRoomPassengerModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    filter?: any[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
}
export class IrregRoomPassengerModelDataSourceLoadOptions extends BaseApiModelClass< IIrregRoomPassengerModelDataSourceLoadOptions > implements IIrregRoomPassengerModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    filter?: any[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
}

export interface IIrregRoomSearchModel {
    rowLimit?: number;
    flightId?: string;
    airlineRcd?: string;
    flightNumber?: number;
    originRcd?: string;
    destinationRcd?: string;
    includeRemoved: boolean;
    includeArchived: boolean;
    isComplete?: boolean;
}
export class IrregRoomSearchModel extends BaseApiModelClass< IIrregRoomSearchModel > implements IIrregRoomSearchModel {
    rowLimit?: number;
    flightId?: string;
    airlineRcd?: string;
    flightNumber?: number;
    originRcd?: string;
    destinationRcd?: string;
    includeRemoved: boolean;
    includeArchived: boolean;
    isComplete?: boolean;
}

export interface IIrregRoomSegment {
    id: string;
    originRcd: string;
    destinationRcd: string;
    airlineRcd: string;
    departureDateTimeUtc?: Date;
    arrivalDateTimeUtc?: Date;
    flightNumber: number;
    undoReason?: string;
}
export class IrregRoomSegment extends BaseApiModelClass< IIrregRoomSegment > implements IIrregRoomSegment {
    id: string;
    originRcd: string;
    destinationRcd: string;
    airlineRcd: string;
    departureDateTimeUtc?: Date;
    arrivalDateTimeUtc?: Date;
    flightNumber: number;
    undoReason?: string;
}

export interface IIrregRoomShortModel {
    key?: any;
    items?: any[];
    count?: number;
    summary?: any[];
    id: string;
    timestamp: Date;
    passengersTotalCount: number;
    createdBy?: string;
    createdAt: Date;
    statistics: IrregRoomStatistic[];
    segments: IrregRoomSegment[];
    isComplete: boolean;
    passengersActualCount: number;
    airlineRcd: string;
    flightNumber: string;
    originRcd: string;
    destinationRcd: string;
    departureDateTimeUtc?: Date;
    arrivalDateTimeUtc?: Date;
    estimatedDepartureDateTimeUtc: Date;
    estimatedArrivalDateTimeUtc: Date;
}
export class IrregRoomShortModel extends BaseApiModelClass< IIrregRoomShortModel > implements IIrregRoomShortModel {
    key?: any;
    items?: any[];
    count?: number;
    summary?: any[];
    id: string;
    timestamp: Date;
    passengersTotalCount: number;
    createdBy?: string;
    createdAt: Date;
    statistics: IrregRoomStatistic[];
    segments: IrregRoomSegment[];
    isComplete: boolean;
    readonly passengersActualCount: number;
    airlineRcd: string;
    flightNumber: string;
    originRcd: string;
    destinationRcd: string;
    departureDateTimeUtc?: Date;
    arrivalDateTimeUtc?: Date;
    estimatedDepartureDateTimeUtc: Date;
    estimatedArrivalDateTimeUtc: Date;
}

export interface IIrregRoomShortModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    filter?: any[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
}
export class IrregRoomShortModelDataSourceLoadOptions extends BaseApiModelClass< IIrregRoomShortModelDataSourceLoadOptions > implements IIrregRoomShortModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    filter?: any[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
}

export interface IIrregRoomStatistic {
    roomId: string;
    status: PassengerStatus;
    count: number;
}
export class IrregRoomStatistic extends BaseApiModelClass< IIrregRoomStatistic > implements IIrregRoomStatistic {
    roomId: string;
    status: PassengerStatus;
    count: number;
}

export interface IIrregRoomUndoModel {
    roomId: string;
    segmentIds: string[];
    undoReason: string;
}
export class IrregRoomUndoModel extends BaseApiModelClass< IIrregRoomUndoModel > implements IIrregRoomUndoModel {
    roomId: string;
    segmentIds: string[];
    undoReason: string;
}

export interface IJobDetailsModel {
    name: string;
    isActive: boolean;
    cronSchedule?: string;
    dateTimeSchedule?: Date;
    parameters: JobParameterDescriptionModel[];
}
export class JobDetailsModel extends BaseApiModelClass< IJobDetailsModel > implements IJobDetailsModel {
    name: string;
    isActive: boolean;
    cronSchedule?: string;
    dateTimeSchedule?: Date;
    parameters: JobParameterDescriptionModel[];
}

export interface IJobEnumModel {
    label: string;
    value: string;
}
export class JobEnumModel extends BaseApiModelClass< IJobEnumModel > implements IJobEnumModel {
    label: string;
    value: string;
}

export enum JobMisfireInstruction {
    Default = "Default",
    DoNothing = "DoNothing",
    FireAndProceed = "FireAndProceed",
    IgnoreMisfires = "IgnoreMisfires",
}

export interface IJobParameterDescriptionModel {
    name: string;
    valueRaw?: string;
    jobValueRaw?: string;
    displayName?: string;
    description?: string;
    type: JobParameterType;
    isRequired: boolean;
    isOverrule?: boolean;
    enumValues: JobEnumModel[];
    permissionName?: string;
}
export class JobParameterDescriptionModel extends BaseApiModelClass< IJobParameterDescriptionModel > implements IJobParameterDescriptionModel {
    name: string;
    valueRaw?: string;
    jobValueRaw?: string;
    displayName?: string;
    description?: string;
    type: JobParameterType;
    isRequired: boolean;
    isOverrule?: boolean;
    enumValues: JobEnumModel[];
    permissionName?: string;
}

export interface IJobParameterModel {
    name: string;
    value?: string;
}
export class JobParameterModel extends BaseApiModelClass< IJobParameterModel > implements IJobParameterModel {
    name: string;
    value?: string;
}

export enum JobParameterType {
    Boolean = "Boolean",
    Date = "Date",
    DateTime = "DateTime",
    Enum = "Enum",
    Integer = "Integer",
    Multiline = "Multiline",
    String = "String",
}

export enum JobPriority {
    High = "High",
    Highest = "Highest",
    Low = "Low",
    Normal = "Normal",
}

export interface IJobSaveParametersModel {
    jobName: string;
    triggerName: string;
    isActive: boolean;
    cronSchedule?: string;
    dateTimeSchedule?: Date;
    parameters?: JobParameterModel[];
    useZrhTimeZone: boolean;
    misfireLogic: JobMisfireInstruction;
    priority: JobPriority;
    isJobSettings: boolean;
}
export class JobSaveParametersModel extends BaseApiModelClass< IJobSaveParametersModel > implements IJobSaveParametersModel {
    jobName: string;
    triggerName: string;
    isActive: boolean;
    cronSchedule?: string;
    dateTimeSchedule?: Date;
    parameters?: JobParameterModel[];
    useZrhTimeZone: boolean;
    misfireLogic: JobMisfireInstruction;
    priority: JobPriority;
    isJobSettings: boolean;
}

export interface IJobSaveParametersResult {
    errors: string[];
    hasErrors: boolean;
}
export class JobSaveParametersResult extends BaseApiModelClass< IJobSaveParametersResult > implements IJobSaveParametersResult {
    errors: string[];
    readonly hasErrors: boolean;
}

export interface IJobStartModel {
    parameters?: JobParameterModel[];
}
export class JobStartModel extends BaseApiModelClass< IJobStartModel > implements IJobStartModel {
    parameters?: JobParameterModel[];
}

export enum JobStatus {
    Fail = "Fail",
    Pending = "Pending",
    Success = "Success",
}

export interface IJobTriggerShortInfo {
    name: string;
    isActive: boolean;
    cronSchedule?: string;
    nextRunDateTime?: Date;
    nextAfterLastRunDateTime?: Date;
    lastRunDateTime?: Date;
    status?: JobStatus;
    progressMax?: number;
    progressCurrent?: number;
    currentMessage?: string;
    scheduleError?: string;
    dateTimeSchedule?: Date;
    useZrhTimeZone: boolean;
    misfireLogic: JobMisfireInstruction;
    priority: JobPriority;
}
export class JobTriggerShortInfo extends BaseApiModelClass< IJobTriggerShortInfo > implements IJobTriggerShortInfo {
    name: string;
    isActive: boolean;
    cronSchedule?: string;
    nextRunDateTime?: Date;
    nextAfterLastRunDateTime?: Date;
    lastRunDateTime?: Date;
    status?: JobStatus;
    progressMax?: number;
    progressCurrent?: number;
    currentMessage?: string;
    scheduleError?: string;
    dateTimeSchedule?: Date;
    useZrhTimeZone: boolean;
    misfireLogic: JobMisfireInstruction;
    priority: JobPriority;
}

export interface ILogFileListItemModel {
    name: string;
    fileName: string;
    extension: string;
    size: number;
    lastModified: Date;
}
export class LogFileListItemModel extends BaseApiModelClass< ILogFileListItemModel > implements ILogFileListItemModel {
    name: string;
    fileName: string;
    extension: string;
    size: number;
    lastModified: Date;
}

export enum MailQueueStatus {
    Cancelled = "Cancelled",
    Failed = "Failed",
    NotSent = "NotSent",
    Sent = "Sent",
}

export enum MailQueueType {
    MasterDataNotification = "MasterDataNotification",
}

export interface IMessageHistoryModel {
    id: string;
    processingDate: Date;
    label: string;
    message: string;
    isOutDirection: boolean;
}
export class MessageHistoryModel extends BaseApiModelClass< IMessageHistoryModel > implements IMessageHistoryModel {
    id: string;
    processingDate: Date;
    label: string;
    message: string;
    isOutDirection: boolean;
}

export enum MessageLabel {
    AcarsM45 = "AcarsM45",
    AcarsOooi = "AcarsOooi",
    Aircraft = "Aircraft",
    AircraftMaintenance = "AircraftMaintenance",
    AircraftsAssignment = "AircraftsAssignment",
    AircraftType = "AircraftType",
    Airport = "Airport",
    AlteaDcsCatering = "AlteaDcsCatering",
    CateredMeals = "CateredMeals",
    CrewAssignment = "CrewAssignment",
    CrewNotification = "CrewNotification",
    Error = "Error",
    Flight = "Flight",
    FlightMeal = "FlightMeal",
    FlightMealService = "FlightMealService",
    FlightPilotStatus = "FlightPilotStatus",
    FlightProtocol = "FlightProtocol",
    FlightWeight = "FlightWeight",
    IrregCase = "IrregCase",
    JeppesenCheckerTrainee = "JeppesenCheckerTrainee",
    JeppesenDuty = "JeppesenDuty",
    JeppesenError = "JeppesenError",
    JeppesenFlight = "JeppesenFlight",
    JeppesenTrip = "JeppesenTrip",
    KafkaReceived = "KafkaReceived",
    LegDetail = "LegDetail",
    Person = "Person",
    PersonAbsence = "PersonAbsence",
    PersonDay = "PersonDay",
    Rotation = "Rotation",
    SabreCrewMessage = "SabreCrewMessage",
    SsimFlightAdded = "SsimFlightAdded",
    SsimFlightDeleted = "SsimFlightDeleted",
    SsimFlightModified = "SsimFlightModified",
    Unknown = "Unknown",
}

export interface IMessageStatisticsItemModel {
    key: string;
    value: number;
}
export class MessageStatisticsItemModel extends BaseApiModelClass< IMessageStatisticsItemModel > implements IMessageStatisticsItemModel {
    key: string;
    value: number;
}

export interface IMessageStatisticsModel {
    messageType: string;
    statistics: MessageStatisticsItemModel[];
    directionType: DirectionType;
}
export class MessageStatisticsModel extends BaseApiModelClass< IMessageStatisticsModel > implements IMessageStatisticsModel {
    messageType: string;
    statistics: MessageStatisticsItemModel[];
    directionType: DirectionType;
}

export interface IPassengerLogFilter {
    rowLimit?: number;
    passengerId: string;
}
export class PassengerLogFilter extends BaseApiModelClass< IPassengerLogFilter > implements IPassengerLogFilter {
    rowLimit?: number;
    passengerId: string;
}

export interface IPassengerLogModel {
    key?: any;
    items?: any[];
    count?: number;
    summary?: any[];
    id: string;
    passengerId: string;
    timestamp: Date;
    changedBy?: string;
    field: string;
    oldValue?: string;
    newValue?: string;
}
export class PassengerLogModel extends BaseApiModelClass< IPassengerLogModel > implements IPassengerLogModel {
    key?: any;
    items?: any[];
    count?: number;
    summary?: any[];
    id: string;
    passengerId: string;
    timestamp: Date;
    changedBy?: string;
    field: string;
    oldValue?: string;
    newValue?: string;
}

export interface IPassengerLogModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    filter?: any[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
}
export class PassengerLogModelDataSourceLoadOptions extends BaseApiModelClass< IPassengerLogModelDataSourceLoadOptions > implements IPassengerLogModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    filter?: any[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
}

export enum PassengerStatus {
    FailedToProcess = "FailedToProcess",
    FailedToSend = "FailedToSend",
    InProgress = "InProgress",
    ManualActionsRequired = "ManualActionsRequired",
    NotRelevant = "NotRelevant",
    NotSent = "NotSent",
    PaxVoided = "PaxVoided",
    Rebooked = "Rebooked",
    RebookedFlown = "RebookedFlown",
    RebookedNotFlown = "RebookedNotFlown",
    RebookingNotNeeded = "RebookingNotNeeded",
    Sent = "Sent",
    Success = "Success",
}

export interface IPermissionModel {
    id: number;
    codeName: string;
    description: string;
}
export class PermissionModel extends BaseApiModelClass< IPermissionModel > implements IPermissionModel {
    id: number;
    codeName: string;
    description: string;
}

export interface IPredefinedRoleModel {
    id: number;
    codeName: string;
    description: string;
    permissionIds: number[];
}
export class PredefinedRoleModel extends BaseApiModelClass< IPredefinedRoleModel > implements IPredefinedRoleModel {
    id: number;
    codeName: string;
    description: string;
    permissionIds: number[];
}

export interface IPrincipalModel {
    id: string;
    displayName: string;
    roles?: string;
}
export class PrincipalModel extends BaseApiModelClass< IPrincipalModel > implements IPrincipalModel {
    id: string;
    displayName: string;
    roles?: string;
}

export interface IQueueStatisticsModel {
    queueName: string;
    messagesCount?: number;
    deadletterMessagesCount?: number;
    messagesPerMinuteIn: number;
    messagesPerMinuteOut: number;
    status: SelfTestResultStatus;
    statusMessage?: string;
}
export class QueueStatisticsModel extends BaseApiModelClass< IQueueStatisticsModel > implements IQueueStatisticsModel {
    queueName: string;
    messagesCount?: number;
    deadletterMessagesCount?: number;
    messagesPerMinuteIn: number;
    messagesPerMinuteOut: number;
    status: SelfTestResultStatus;
    statusMessage?: string;
}

export interface IReloadPassengersData {
    roomId: string;
    pnrs: string[];
    acceptWarnings: boolean;
}
export class ReloadPassengersData extends BaseApiModelClass< IReloadPassengersData > implements IReloadPassengersData {
    roomId: string;
    pnrs: string[];
    acceptWarnings: boolean;
}

export enum SchedulerStatus {
    FailedToStart = "FailedToStart",
    SchedulingJobs = "SchedulingJobs",
    SchedulingPostponedJobs = "SchedulingPostponedJobs",
    ServiceNotStarted = "ServiceNotStarted",
    ShutDown = "ShutDown",
    ShuttingDown = "ShuttingDown",
    Started = "Started",
    Starting = "Starting",
    WaitingForDatabase = "WaitingForDatabase",
}

export interface ISelfTestResult {
    name: string;
    status: SelfTestResultStatus;
    title?: string;
    message?: string;
    payload?: any;
}
export class SelfTestResult extends BaseApiModelClass< ISelfTestResult > implements ISelfTestResult {
    name: string;
    status: SelfTestResultStatus;
    title?: string;
    message?: string;
    payload?: any;
}

export enum SelfTestResultStatus {
    Fail = "Fail",
    Success = "Success",
    Warning = "Warning",
}

export interface ISortingInfo {
    selector?: string;
    desc: boolean;
}
export class SortingInfo extends BaseApiModelClass< ISortingInfo > implements ISortingInfo {
    selector?: string;
    desc: boolean;
}

export interface ISummaryInfo {
    selector?: string;
    summaryType?: string;
}
export class SummaryInfo extends BaseApiModelClass< ISummaryInfo > implements ISummaryInfo {
    selector?: string;
    summaryType?: string;
}

export interface ITaxConfigFilter {
    rowLimit?: number;
}
export class TaxConfigFilter extends BaseApiModelClass< ITaxConfigFilter > implements ITaxConfigFilter {
    rowLimit?: number;
}

export interface ITaxConfigModel {
    key?: any;
    items?: any[];
    count?: number;
    summary?: any[];
    id: string;
    amount: number;
    dateFrom?: Date;
    dateTo?: Date;
}
export class TaxConfigModel extends BaseApiModelClass< ITaxConfigModel > implements ITaxConfigModel {
    key?: any;
    items?: any[];
    count?: number;
    summary?: any[];
    id: string;
    amount: number;
    dateFrom?: Date;
    dateTo?: Date;
}

export interface ITaxConfigModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    filter?: any[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
}
export class TaxConfigModelDataSourceLoadOptions extends BaseApiModelClass< ITaxConfigModelDataSourceLoadOptions > implements ITaxConfigModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    filter?: any[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
}

export interface ITemplateFormattingModel {
    template: TemplateModel;
    dataModel?: string;
}
export class TemplateFormattingModel extends BaseApiModelClass< ITemplateFormattingModel > implements ITemplateFormattingModel {
    template: TemplateModel;
    dataModel?: string;
}

export interface ITemplateGenericParameterDescriptionModel {
    displayName?: string;
    text?: string;
}
export class TemplateGenericParameterDescriptionModel extends BaseApiModelClass< ITemplateGenericParameterDescriptionModel > implements ITemplateGenericParameterDescriptionModel {
    displayName?: string;
    text?: string;
}

export interface ITemplateGroupModel {
    name?: string;
    codes: TemplateItemModel[];
}
export class TemplateGroupModel extends BaseApiModelClass< ITemplateGroupModel > implements ITemplateGroupModel {
    name?: string;
    codes: TemplateItemModel[];
}

export interface ITemplateItemModel {
    code: string;
    displayName: string;
}
export class TemplateItemModel extends BaseApiModelClass< ITemplateItemModel > implements ITemplateItemModel {
    code: string;
    displayName: string;
}

export interface ITemplateModel {
    group?: string;
    to?: string;
    cc?: string;
    bcc?: string;
    subject: string;
    body: string;
    genericParameters: TemplateGenericParameterDescriptionModel[];
    errors: { [key: string]: string; };
}
export class TemplateModel extends BaseApiModelClass< ITemplateModel > implements ITemplateModel {
    group?: string;
    to?: string;
    cc?: string;
    bcc?: string;
    subject: string;
    body: string;
    genericParameters: TemplateGenericParameterDescriptionModel[];
    errors: { [key: string]: string; };
}

export interface ITimeModel {
    dateTime: Date;
    timeZone?: string;
}
export class TimeModel extends BaseApiModelClass< ITimeModel > implements ITimeModel {
    dateTime: Date;
    timeZone?: string;
}

export interface ITimeTransitionEvent {
    timeUtc: Date;
    minutesUtcTimeDiff: number;
}
export class TimeTransitionEvent extends BaseApiModelClass< ITimeTransitionEvent > implements ITimeTransitionEvent {
    timeUtc: Date;
    minutesUtcTimeDiff: number;
}

export interface IUpsertGuidelineModel {
    id?: string;
    title: string;
    text: string;
}
export class UpsertGuidelineModel extends BaseApiModelClass< IUpsertGuidelineModel > implements IUpsertGuidelineModel {
    id?: string;
    title: string;
    text: string;
}

export interface IUpsertIrregRoomModel {
    roomId?: string;
    bookableSegments: IrregRoomBookableSegmentModel[];
}
export class UpsertIrregRoomModel extends BaseApiModelClass< IUpsertIrregRoomModel > implements IUpsertIrregRoomModel {
    roomId?: string;
    bookableSegments: IrregRoomBookableSegmentModel[];
}

export interface IValidationContext {
    passengerId: string;
    errors: ValidationError[];
}
export class ValidationContext extends BaseApiModelClass< IValidationContext > implements IValidationContext {
    passengerId: string;
    errors: ValidationError[];
}

export interface IValidationError {
    message?: string;
    ruleId: string;
    source?: string;
    property: string;
}
export class ValidationError extends BaseApiModelClass< IValidationError > implements IValidationError {
    message?: string;
    ruleId: string;
    source?: string;
    property: string;
}

export interface IValidationRuleModel {
    id: string;
    validatorType: string;
    validatorOptions: string;
    isAutoCorrection: boolean;
}
export class ValidationRuleModel extends BaseApiModelClass< IValidationRuleModel > implements IValidationRuleModel {
    id: string;
    validatorType: string;
    validatorOptions: string;
    isAutoCorrection: boolean;
}

export interface IValidatorDetails {
    name: string;
    displayName?: string;
    parameters: ValidatorParameter[];
}
export class ValidatorDetails extends BaseApiModelClass< IValidatorDetails > implements IValidatorDetails {
    name: string;
    displayName?: string;
    parameters: ValidatorParameter[];
}

export interface IValidatorParameter {
    name: string;
    displayName?: string;
    isRequired: boolean;
    type: ValidatorParameterType;
    selectOptions: ValidatorSelectOption[];
}
export class ValidatorParameter extends BaseApiModelClass< IValidatorParameter > implements IValidatorParameter {
    name: string;
    displayName?: string;
    isRequired: boolean;
    type: ValidatorParameterType;
    selectOptions: ValidatorSelectOption[];
}

export enum ValidatorParameterType {
    Boolean = "Boolean",
    DateTime = "DateTime",
    Integer = "Integer",
    List = "List",
    String = "String",
}

export interface IValidatorSelectOption {
    propertyName: string;
    value: string;
}
export class ValidatorSelectOption extends BaseApiModelClass< IValidatorSelectOption > implements IValidatorSelectOption {
    propertyName: string;
    value: string;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}